/**
 * component/error404/index
 */

import React from 'react';
import Grid from 'material-ui/Grid';
import Helmet from "../Helmet";
import PAGE_CONFIG from '../../config/error404.json';
import { Link } from 'react-router-dom';
import { initGA } from '../GA';
import Button from 'material-ui/Button';

class Error404 extends React.Component{
  componentDidMount(){
    initGA();
  }
  
  render(){
    return (
      <div className="center-container">
        <Helmet title={PAGE_CONFIG.title} description={PAGE_CONFIG.description} />
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">{PAGE_CONFIG.title}</h1>
                <p className="contents-sub-title">{PAGE_CONFIG.sub_title}</p>
              </div>
              <div className="middle-container error404-container center">
              
                  <h2 className="error-h2">404</h2>
                  <Link to="/">
                  <Button variant="raised" size="medium" style={{marginTop:20}} color="primary">
                    Home
                  </Button>
                  </Link>
                </div>
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default Error404



// WEBPACK FOOTER //
// ./src/component/error404/index.js